import './components.less'
import WidgetCard from '../../../components/Card'
import React from 'react'

const Card: React.FC<
  React.HTMLProps<HTMLDivElement> & {
    cardTitle?: React.ReactNode
    cardTitleClassName?: string
    cardFooter?: React.ReactNode
  }
> = ({ ...rest }) => {
  return <WidgetCard {...rest} />
}

export default Card
